<template>
  <figure v-for="image in images" :key="image.src" class="guide-screenshot" :style="{ maxWidth: `${Math.min(image.width, 560)}px` }">
    <a :href="image.src" target="_blank" rel="noopener noreferrer" :aria-label="`${image.alt} In Originalgröße öffnen (neuer Tab).`">
      <img :src="image.src" :alt="image.alt" :width="image.width" :height="image.height" loading="lazy" />
    </a>
    <figcaption>Bild anklicken, um es zu vergrößern.</figcaption>
  </figure>
</template>

<script>
export default {
  name: 'GuideScreenshots',
  props: {
    images: { type: Array, default: () => [] },
  },
}
</script>

<style scoped lang="scss">
.guide-screenshot {
  width: 100%;
  margin: 1rem 0 0;
  padding: 0.625rem;
  background: #f3f6f8;
  border: 1px solid #dce4ea;
  border-radius: 0.25rem;

  a {
    display: block;
    cursor: zoom-in;

    &:focus-visible {
      outline: 2px solid #10273d;
      outline-offset: 3px;
    }
  }

  img {
    display: block;
    width: 100%;
    height: auto;
    background: #fff;
  }

  figcaption {
    margin-top: 0.5rem;
    color: #4f6273;
    font-size: 0.8rem;
    line-height: 1.4;
  }
}
</style>
